import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";
const baseUrl = `${BASE_URL}/order-cart`;

const getInvoiceByComp = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/invoice/get-invoices`, { params })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const getInvoiceByInvId = async (id: string) => {
  return await httpClient
    .get(`${baseUrl}/invoice/${id}`)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const createPayment = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/invoice/create-payment`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const updatePayment = async (params: object) => {
  return await httpClient
    .put(`${baseUrl}/invoice/update-payment`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

const deletePayment = async (params: any) => {
  return await httpClient
    .delete(`${baseUrl}/invoice/delete-payment/${params.invoicePaymentId}/${params.updatedBy}`, {
      params,
    })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

export { getInvoiceByComp, getInvoiceByInvId, createPayment, updatePayment, deletePayment };
